
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './context/AuthContext';
import { enforceHttps, setHSTSMeta } from './utils/httpsRedirect';
import './index.css';

// Enforce HTTPS and security headers
enforceHttps();
setHSTSMeta();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
